import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    localize,
} from 'wanderu-i18n';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './FormError.scss';

export function FormError({
    t, className, noValue, unknown, children,
}) {
    return (
        <div className={classNames(
            styles.errorContainer,
            className,
        )}>
            {noValue && (
                <span>{t('empty-form-error')}</span>
            )}

            {unknown && (
                <span>{t('unknown-form-error')}</span>
            )}
            {children}
        </div>
    );
}

FormError.propTypes = {
    className: PropTypes.string,
    noValue: PropTypes.bool,
    unknown: PropTypes.bool,
};

FormError.defaultProps = {
    className: '',
    noValue: false,
    unknown: false,
};

export default localize(FormError, baseAppConfig.namespace);
